import { ensureAllUserProjectsFetched } from '@common/modules/projects/stores/projects.actions'
import { getCurrentWorkspace, getWorkspacesByUserId } from '@common/modules/workspaces/stores/workspaces.actions'
import type { Workspace } from '@common/modules/workspaces/types'

async function loadWorkspaceListAndCurrentWorkspace(): Promise<Workspace | null> {
  await getWorkspacesByUserId()
  return getCurrentWorkspace()
}

/**
 * After `getCurrentUser`, runs workspaces load, user-wide projects prefetch, and regional init in parallel.
 */
export async function runInitialAppDataParallelBatch(
  initializeUserRegionalData: () => Promise<void>
): Promise<{ workspace: Workspace | null }> {
  const [workspace] = await Promise.all([
    loadWorkspaceListAndCurrentWorkspace(),
    ensureAllUserProjectsFetched(),
    initializeUserRegionalData(),
  ])
  return { workspace }
}
